import axios from '../request.js';

export default {
  /**
   * 流程汇总列表
   * @param {Object} params { page, pageSize, status?, target_type?, applicant_id?, created_start?, created_end? }
   * @returns {Promise<{ code, result: { list, total, page, pageSize }, msg }>}
   */
  getList: async (params = {}) => {
    const res = await axios.get('/Api/WorkflowPush/list', { params });
    return res.data;
  },

  /**
   * 流程汇总详情
   * @param {number} id 记录 id
   * @returns {Promise<{ code, result: Object, msg }>}
   */
  getDetail: async (id) => {
    const res = await axios.get('/Api/WorkflowPush/detail', { params: { id } });
    return res.data;
  },

  /**
   * 业务类型下拉（客户/企业）
   * @param {string} target_type 'client' | 'company'
   * @returns {Promise<{ code, result: { list: { value, label }[] }, msg }>}
   */
  businessTypes: async (target_type = 'client') => {
    const res = await axios.get('/Api/WorkflowPush/businessTypes', {
      params: { target_type },
    });
    return res.data;
  },

  /**
   * 可推送对象下拉（二级/三级用户）
   * @param {number|null} push_target_level 可选 2 | 3，不传则返回 2 和 3
   * @returns {Promise<{ code, result: { list: { u_id, u_name, u_account, u_level }[] }, msg }>}
   */
  pushTargetUsers: async (push_target_level = null) => {
    const params = push_target_level ? { push_target_level } : {};
    const res = await axios.get('/Api/WorkflowPush/pushTargetUsers', { params });
    return res.data;
  },

  /**
   * 创建推送（仅三级可调用）
   * @param {Object} body
   * @param {string} body.target_type 'client' | 'company'
   * @param {number} body.target_id client_id 或 company_id
   * @param {number} body.push_target_level 2 | 3
   * @param {number[]} body.push_target_ids 接收人 u_id 数组
   * @param {string} body.business_type 业务类型编码
   * @param {string} [body.business_other] 选「其他」时必填
   * @param {string} [body.applicant_remark] 备注
   * @param {number} [body.parent_id] 父流程 id（继续推送时传，作为子流水）
   */
  create: async (body) => {
    const payload = {
      ...body,
      push_target_ids: Array.isArray(body.push_target_ids)
        ? JSON.stringify(body.push_target_ids)
        : body.push_target_ids,
    };
    if (body.parent_id != null) {
      payload.parent_id = body.parent_id;
    }
    const res = await axios.post('/Api/WorkflowPush/create', payload);
    return res.data;
  },

  /**
   * 审核（通过/拒绝）- 仅被推送人且 status=pending 可调用
   * @param {number} id 流程记录 id
   * @param {string} action 'approve' | 'reject'
   * @param {string} [reject_reason] 拒绝原因（拒绝时建议传）
   * @param {number} [rework_u_id] 驳回后返工人 u_id（reject 必填）
   */
  review: async (id, action, reject_reason, rework_u_id) => {
    const payload = { id, action };
    if (action === 'reject' && reject_reason != null) {
      payload.reject_reason = reject_reason;
    }
    if (action === 'reject' && rework_u_id != null) {
      payload.rework_u_id = rework_u_id;
    }
    const res = await axios.post('/Api/WorkflowPush/review', payload);
    return res.data;
  },

  /**
   * 返工人直接提交二级审核
   * @param {Object} body
   * @param {number} [body.root_id]
   * @param {number} [body.client_id]
   * @param {number[]} body.push_target_ids 二级审核人（后端目前要求仅 1 个）
   */
  reworkSubmit: async (body) => {
    const payload = {
      ...body,
      push_target_ids: Array.isArray(body.push_target_ids)
        ? JSON.stringify(body.push_target_ids)
        : body.push_target_ids,
    };
    const res = await axios.post('/Api/WorkflowPush/rework_submit', payload);
    return res.data;
  },
};
